const CONFIG = {
    BASE_URL: "https://api-leafcheck-production.up.railway.app",
};
  
export default CONFIG;
  